import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import Logo from "./Logo";
import { LOAN_PRODUCTS, COMPANY_PHONE, COMPANY_EMAIL, COMPANY_ADDRESS } from "../lib/api";

export default function Footer() {
  return (
    <footer className="bg-[#06152D] text-white lj-grain">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <Logo size={52} variant="light" withWordmark />
          <p className="mt-6 text-sm text-[#B5C4E1] max-w-md leading-relaxed">
            Your trusted loan and insurance partner. We proudly serve customers across
            Telangana, connecting individuals, families and businesses with leading banks
            &amp; NBFCs through a transparent and professional process.
          </p>
          <div className="mt-6 space-y-2 text-sm">
            <div className="flex items-center gap-2 text-[#B5C4E1]"><Phone size={14} /> {COMPANY_PHONE}</div>
            <div className="flex items-center gap-2 text-[#B5C4E1]"><Mail size={14} /> {COMPANY_EMAIL}</div>
            <div className="flex items-center gap-2 text-[#B5C4E1]"><MapPin size={14} /> {COMPANY_ADDRESS}</div>
          </div>
        </div>

        <div>
          <div className="text-xs font-semibold tracking-[0.2em] uppercase text-[#EBF2FF] mb-4">Loan Products</div>
          <ul className="space-y-2">
            {LOAN_PRODUCTS.slice(0, 6).map((p) => (
              <li key={p.slug}>
                <Link to={`/services/${p.slug}`} className="text-sm text-[#B5C4E1] hover:text-white" data-testid={`footer-service-${p.slug}`}>
                  {p.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-xs font-semibold tracking-[0.2em] uppercase text-[#EBF2FF] mb-4">Company</div>
          <ul className="space-y-2">
            <li><Link to="/about" className="text-sm text-[#B5C4E1] hover:text-white">About Us</Link></li>
            <li><Link to="/emi-calculator" className="text-sm text-[#B5C4E1] hover:text-white">EMI Calculator</Link></li>
            <li><Link to="/eligibility" className="text-sm text-[#B5C4E1] hover:text-white">Eligibility</Link></li>
            <li><Link to="/apply" className="text-sm text-[#B5C4E1] hover:text-white">Apply Online</Link></li>
            <li><Link to="/contact" className="text-sm text-[#B5C4E1] hover:text-white">Contact</Link></li>
            <li><Link to="/faq" className="text-sm text-[#B5C4E1] hover:text-white">FAQ</Link></li>
            <li><Link to="/privacy" className="text-sm text-[#B5C4E1] hover:text-white">Privacy Policy</Link></li>
            <li><Link to="/terms" className="text-sm text-[#B5C4E1] hover:text-white">Terms &amp; Conditions</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-[#B5C4E1]">
          <div>© {new Date().getFullYear()} Loan Junction Finance Services · Serving Across Telangana</div>
          <div>Loans are subject to approval by partner banks/NBFCs. T&amp;C apply.</div>
        </div>
      </div>
    </footer>
  );
}
